const table = {
  perPage: 5,
};

export default table;
